import A from './types';

const initialState = {
  hideConfirm: false,
  id: null,
  company: '',
};
const reducer = (state, action) => {
  switch (action.type) {
    case A.ALTER_HIDE_CONFIRM: {
      return {
        hideConfirm: action.payload.hideConfirm,
        id: action.payload.id,
        company: action.payload.company,
      };
    }
  }
  return null;
};
export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/hideConfirm/reducer.js